import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#505050",
      "fill-rule": "evenodd",
      d: "M16.514 11.178a1.75 1.75 0 0 1 2.474 0l1.023 1.022-.337.51a.61.61 0 0 0 .098.76.62.62 0 0 0 .672.143l.085-.047.511-.336 1.032 1.034a1.75 1.75 0 0 1 0 2.474l-5.335 5.334a1.75 1.75 0 0 1-2.475 0l-1.03-1.029.328-.508a.61.61 0 0 0-.101-.753.61.61 0 0 0-.753-.102l-.508.328-1.02-1.022a1.75 1.75 0 0 1 0-2.474zm1.414 1.06a.25.25 0 0 0-.354 0l-5.336 5.334a.25.25 0 0 0 0 .354l.238.238a2.12 2.12 0 0 1 2.043.558 2.12 2.12 0 0 1 .556 2.043l.247.247a.25.25 0 0 0 .355 0l5.335-5.334a.25.25 0 0 0 0-.354l-.242-.242a2.12 2.12 0 0 1-2.06-.552 2.12 2.12 0 0 1-.552-2.061z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#505050",
      d: "M16 2.25a.75.75 0 0 1 .75.75v1.25H20c.966 0 1.75.784 1.75 1.75v2a.75.75 0 0 1-1.5 0V6a.25.25 0 0 0-.25-.25h-3.25V7a.75.75 0 0 1-1.5 0V5.75h-6.5V7a.75.75 0 0 1-1.5 0V5.75H4a.25.25 0 0 0-.25.25v13c0 .138.112.25.25.25h4a.75.75 0 0 1 0 1.5H4A1.75 1.75 0 0 1 2.25 19V6c0-.966.784-1.75 1.75-1.75h3.25V3a.75.75 0 0 1 1.5 0v1.25h6.5V3a.75.75 0 0 1 .75-.75"
    }, null, -1)
  ])))
}
export default { render: render }